import { getDataProperty, getBoundingPageRect } from '../utils/_domFunctions';

class mPdVerdyLogoBounce extends HTMLDivElement {
    constructor() {
        super();
        this.pageEl = null;
        this.overlayEl = null;
        this.sheetEl = null;
        this.logoSizeDesktop = 0;
        this.logoSizeMobile = 0;
        this.animationDelay = 0;
        this.animationDuration = 0;
        this.step = 0;
    }

    connectedCallback() {
        // Get dataset values
        this.logoSizeDesktop = getDataProperty(this, 'logoSize', 'number', 100);
        this.logoSizeMobile = getDataProperty(this, 'logoSizeMobile', 'number', this.logoSize);
        this.animationDurationDesktop = getDataProperty(this, 'animationDuration', 'number', 5);
        this.animationDurationMobile = getDataProperty(this, 'animationDurationMobile', 'number', this.animationDurationMobile);
        this.animationDelay = getDataProperty(this, 'animationDelay', 'number', 15) * 1000;
        this.animationFallDesktop = getDataProperty(this, 'animationFall', 'number', 50);
        this.animationFallMobile = getDataProperty(this, 'animationFallMobile', 'number', this.animationFall);

        // Get page designer body
        this.pageEl = this.closest('.page-designer-reference');
        if (!this.pageEl) {
            throw new Error('Cannot find page designer body');
        }

        // Create overlay with logo from template
        const template = this.querySelector('template');
        if (!template) {
            throw new Error('Missing template');
        }
        this.sheetEl = document.createElement('div');
        this.sheetEl.className = 'verdy-logo-bounce-sheet';
        this.sheetEl.appendChild(...template.content.cloneNode(true).children);
        this.overlayEl = document.createElement('div');
        this.overlayEl.className = 'verdy-logo-bounce-overlay';
        this.overlayEl.style.setProperty('--sheet-size-desktop', `${this.logoSizeDesktop}px`);
        this.overlayEl.style.setProperty('--sheet-size-mobile', `${this.logoSizeMobile}px`);
        this.overlayEl.style.setProperty('--animation-duration-desktop', `${this.animationDurationDesktop}s`);
        this.overlayEl.style.setProperty('--animation-duration-mobile', `${this.animationDurationMobile}s`);
        this.overlayEl.style.setProperty('--animation-fall-desktop', `${this.animationFallDesktop}vh`);
        this.overlayEl.style.setProperty('--animation-fall-mobile', `${this.animationFallMobile}vh`);
        this.overlayEl.appendChild(this.sheetEl);
        this.pageEl.appendChild(this.overlayEl);

        // Setup animation
        this.sheetEl.addEventListener('animationend', this.onAnimationEnd.bind(this));
        this.resetAnimationStep();
        this.startAnimation();
    }

    disconnectedCallback() {}

    resetAnimationStep() {
        this.step = 0;
        const componentRect = getBoundingPageRect(this);
        const overlayRect = getBoundingPageRect(this.overlayEl);
        const topOffset = componentRect.y - overlayRect.y;
        this.sheetEl.style.setProperty('top', `${topOffset}px`);
    }

    startAnimation() {
        this.sheetEl.classList.add('animate');
        setTimeout(this.startAnimation.bind(this), this.animationDelay);
    }

    onAnimationEnd() {
        const overlayRect = getBoundingPageRect(this.overlayEl);
        const sheetRect = getBoundingPageRect(this.sheetEl);
        if (sheetRect.bottom >= overlayRect.bottom) {
            // Sheet will be out of bounds ; Resetting top position
            this.resetAnimationStep();
        } else {
            // Move logo inital top position
            const sheetTopPos = sheetRect.top - overlayRect.top;
            this.sheetEl.style.setProperty('top', `${sheetTopPos}px`);
            this.step += 1;
        }
        this.sheetEl.classList.remove('animate');
    }
}

customElements.define('m-pd-verdy-logo-bounce', mPdVerdyLogoBounce, {
    extends: 'div'
});
